module.exports = __webpack_public_path__ + "img/workforce-elders.ea44fec6.webp";